import { refreshCartItemsSections, updateCartBubbles } from './quick-add-cart.js';

const UPSELL_SECTION = 'cart-drawer-upsell';
let upsellFetchController = null;

function formatCartUpsellMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
  return '$' + (Number(cents) / 100).toFixed(2);
}

function onCartUpsellVariantChange(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const form = selectElement.closest('form');
  const addButton = form?.querySelector('.btn-atc');
  const productItem = selectElement.closest('.product-item');
  const variantAvailable = selectedOption.getAttribute('data-available') === 'true';

  if (addButton) {
    addButton.disabled = !variantAvailable;
    addButton.textContent = variantAvailable ? (addButton.dataset.textAddToCart || 'ADD') : 'Sold out';
  }

  const priceElement = productItem?.querySelector('.product-item-price-final .money');
  const compareWrap = productItem?.querySelector('.product-item-price-compare');
  const compareElement = productItem?.querySelector('.product-item-price-compare s .money');
  const variantPrice = selectedOption.getAttribute('data-price');
  const variantComparePrice = selectedOption.getAttribute('data-compare-at-price');

  if (priceElement && variantPrice) {
    priceElement.textContent = formatCartUpsellMoney(variantPrice);
  }

  if (compareWrap && compareElement) {
    if (parseInt(variantComparePrice, 10) > parseInt(variantPrice, 10)) {
      compareElement.textContent = formatCartUpsellMoney(variantComparePrice);
      compareWrap.style.display = '';
    } else {
      compareWrap.style.display = 'none';
    }
  }

  const variantImageSrc = selectedOption.getAttribute('data-variant-image');
  const productImage = productItem?.querySelector('.product-item-img');
  if (variantImageSrc && productImage) {
    productImage.src = variantImageSrc;
  }
}

export async function loadCartUpsell() {
  const mount = document.getElementById('cart-upsell-mount');
  if (!mount) return;

  if (upsellFetchController) {
    upsellFetchController.abort();
  }
  upsellFetchController = new AbortController();

  mount.classList.add('is-loading');

  try {
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}?sections=${UPSELL_SECTION}&_=${Date.now()}`;
    const response = await fetch(url, { signal: upsellFetchController.signal });
    if (!response.ok) throw new Error('Upsell section fetch failed');

    const data = await response.json();
    const html = data[UPSELL_SECTION];
    if (!html) return;

    mount.innerHTML = html;

    mount.querySelectorAll('.cart-upsell-variant-select').forEach((select) => {
      if (select instanceof HTMLSelectElement) {
        onCartUpsellVariantChange(select);
      }
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') return;
    console.error('Cart upsell load error:', error);
  } finally {
    mount.classList.remove('is-loading');
  }
}

async function handleUpsellSubmit(form) {
  const btn = form.querySelector('.btn-atc');
  const select = form.querySelector('.cart-upsell-variant-select');
  const hiddenId = form.querySelector('input[name="id"]');
  const variantId = select ? Number(select.value) : Number(hiddenId?.value);
  if (!variantId || btn?.disabled) return;

  btn.classList.add('loading');
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('Add failed');

    const cart = await fetch('/cart.js').then((r) => r.json());
    updateCartBubbles(cart.item_count);
    await refreshCartItemsSections();

    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  } catch (err) {
    console.error('Cart upsell add error:', err);
  } finally {
    btn.classList.remove('loading');
    if (select instanceof HTMLSelectElement) {
      onCartUpsellVariantChange(select);
    } else if (btn) {
      btn.disabled = false;
    }
  }
}

document.addEventListener('change', (e) => {
  const select = e.target.closest?.('.cart-upsell-variant-select');
  if (!(select instanceof HTMLSelectElement)) return;
  onCartUpsellVariantChange(select);
});

document.addEventListener('submit', (e) => {
  const form = e.target.closest?.('.cart-upsell-form');
  if (!(form instanceof HTMLFormElement)) return;
  e.preventDefault();
  handleUpsellSubmit(form);
});
